import React from "react";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from "@material-ui/pickers";
import { DATE_FORMAT } from "../constants/index";
import { FormHelperText, FormControl } from "@material-ui/core";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";

interface DateTimePickerProps {
	//The date that the start date picker should be populated with
	selectedDate: Date;
	//The date that the end date picker should be populated with
	//A Callback function used to set the parents start and end date.
	//Should take in a single object containing start and end date.
	setDate: (newDate: Date) => void;
	//This is the label that will appear over the date picker.
	datePickerLabel: string;
	//This is the message that will be shown if invalid data is passed back to the filter container.
	errorMessage?: string;
	//This is the message that will be shown if a helper message is passed in the filter container.
	helperMessage?: string;
	//The minimum date that can be selected on the calender.
	minimumDate?: Date;
	//The maximum date that can be selected on the calender.
	maximumDate?: Date;
}
/**
 * Accepts a start date and an end date as well as a callback
 * function for sending the new dates back .
 * @param props
 */
export const DateTimePicker = (props: DateTimePickerProps) => {
	const [internalError, setInternalError] = React.useState("");
	const hasError = !!props.errorMessage || !!internalError;

	const displayHelperText = () => {
		if (hasError) {
			return <FormHelperText error={hasError}>{props.errorMessage || internalError}</FormHelperText>;
		} else {
			return <FormHelperText>{props.helperMessage}</FormHelperText>;
		}
	};

	const onDateChange = (date: MaterialUiPickersDate) => {
		if (date && date.isValid()) {
			props.setDate(date.toDate());
			setInternalError("");
		} else {
			setInternalError("Invalid date");
		}
	};

	return (
		<FormControl>
			<MuiPickersUtilsProvider utils={MomentUtils}>
				<KeyboardDateTimePicker
					error={hasError}
					allowKeyboardControl={true}
					disableToolbar
					disableFuture={true}
					variant="inline"
					format={DATE_FORMAT}
					minDate={props.minimumDate}
					minDateMessage={props.helperMessage}
					maxDate={props.maximumDate}
					maxDateMessage={props.helperMessage}
					ampm={false}
					margin="normal"
					data-testid="date-picker"
					label={props.datePickerLabel}
					value={props.selectedDate}
					onChange={onDateChange}
					KeyboardButtonProps={{
						hidden: true,
						"aria-label": "change date",
					}}
				></KeyboardDateTimePicker>
				{displayHelperText()}
				<KeyboardDateTimePicker
					error={hasError}
					allowKeyboardControl={true}
					disableToolbar
					disableFuture={true}
					variant="static"
					format={DATE_FORMAT}
					minDate={props.minimumDate}
					maxDate={props.maximumDate}
					views={["date"]}
					ampm={false}
					margin="normal"
					data-testid="date-picker"
					label={props.datePickerLabel}
					value={props.selectedDate}
					onChange={onDateChange}
					KeyboardButtonProps={{
						"aria-label": "change date",
					}}
				></KeyboardDateTimePicker>
			</MuiPickersUtilsProvider>
		</FormControl>
	);
};
